import { ProgramsPaths } from '@context/ProgramsPaths/Context'
import {
  ProgramCategoryList,
  ProgramCategoryName,
  Slugs,
} from '@type/buzzkuri/programs-categor'

export const jaToRoman = (
  slugs: Slugs,
  programCategoryList: ProgramCategoryList
): string => {
  if (slugs.length === 1 && Number(slugs[0]) > 0) {
    return slugs[0]
  } else {
    const programCategoryArr: ProgramCategoryName[] = []
    Object.values(programCategoryList).forEach((list) => {
      programCategoryArr.push(...list)
    })
    const endpointPaths = slugs.map(
      (slug) =>
        programCategoryArr.filter((list) => list.name === slug)[0]?.roman
    )
    const roman =
      endpointPaths.filter((v) => v).length === slugs.length
        ? endpointPaths.join('/')
        : ''

    return roman
  }
}

const programsCategories = (
  slugs: Slugs,
  programCategoryList: ProgramCategoryList
) =>
  slugs.map((slug) => {
    const key =
      Number(slug) > 0
        ? 'programId'
        : programCategoryList.objectives.filter(({ name }) => name === slug)
            .length > 0
        ? 'objective'
        : programCategoryList.genres.filter(({ name }) => name === slug)
            .length > 0
        ? 'genre'
        : programCategoryList.tags.filter(({ name }) => name === slug).length >
          0
        ? 'tag'
        : ''
    return { [key]: slug }
  })

export const getProgramsPaths = (
  slugs: Slugs,
  programCategoryList: ProgramCategoryList
): ProgramsPaths => {
  let programs = {} as ProgramsPaths
  programsCategories(slugs, programCategoryList)
    .filter((programObj) =>
      ['objective', 'genre'].includes(Object.keys(programObj)[0])
    )
    .forEach((program) => {
      programs = { ...programs, ...program }
    })
  return programs
}
